<template>
	<div class="delteWrapper">
		<div class="deleteBtnWrapper"
			 v-on:click.stop.prevent="showDeleteDialog = true">
			<svg class="deleteBtn">
				<line x1="0" y1="0" x2="12" y2="12"
					  stroke-width="2"/>
				<line x1="12" y1="0" x2="0" y2="12"
					  stroke-width="2"/>
			</svg>
			<span class="tooltip">Step löschen</span>
		</div>

		<div class="deleteDialog" v-show="showDeleteDialog">
			<div class="deleteText">Sind Sie sicher, dass Sie diesen Step
				löschen wollen?
			</div>
			<div class="btnGroup">
				<button class="btn" v-on:click.stop.prevent="stepDelete()">Ja
				</button>
				<button class="btn"
						v-on:click.stop.prevent="showDeleteDialog = false">Nein
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Show from '@/services/Show';
	import Step from '@/services/Step';

	export default {
		name: "ShowEditDelte",
		props: ["showDelete", "step"],
		data() {
			return {
				showDeleteDialog: false
			}
		},
		methods: {
			async stepDelete() {
				this.showDeleteDialog = false;
				await Step.delete(this.step);

				let show = this.showDelete;
				show.step_order = show.step_order.filter(stepOrder => stepOrder !== this.step.id);
				await Show.put(show);

				this.$emit('reloadShow');
			}
		}
	}
</script>

<style scoped>
	.deleteBtn {
		stroke: white;
		cursor: pointer;
	}

	.deleteBtn {
		stroke: gray;
		width: 20px;
		height: 13px;
	}

	.deleteDialog {
		cursor: default;
		background: rgba(0, 0, 0, 0.75);
		color:white;
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		padding: 20px;
		z-index: 99;
	}

	.deleteText {
		font-size: 14px;
		text-align: left;
		margin-top: 40px;
	}

	.btnGroup {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.btn {
		font-family: "BrownLLWeb-Regular";
		font-size: 22px;
		background-color: white;
		padding: 4px 6px 4px 6px;
		margin: 20px 10px 10px 10px;
		cursor: pointer;
		border: none;
	}

	.deleteBtnWrapper .tooltip {
		visibility: hidden;
		color: #fff;
		text-align: right;
		position: absolute;
		width: 136px;
		top: 2px;
		right: 25px;
		background-color: black;
		z-index: 1;
	}

	.deleteBtnWrapper:hover .deleteBtn {
		stroke: white;
	}

	.deleteBtnWrapper:hover .tooltip {
		visibility: visible;
	}
</style>